import React from 'react';
import { DocumentPage } from '@auw/workspace-ui';

const DocumentModePage: React.FC = () => {
  return <DocumentPage />;
};

export default DocumentModePage;
